import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { OrdersCoServices } from '../../orders/services';
/*
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
*/

@Component({
    selector: 'page-kitchen-order-print',
    templateUrl: 'kitchen-order-print.html',
})
export class KitchenOrderPrintPage {
    footer: any;
    header: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public ordersCoServices: OrdersCoServices) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/kitchen/kitchen-order-print/kitchen-order-print.ts